import {
  handleResp,
  getURLWithQueryParams,
  getDefaultHeaders,
  extendFetchOptions,
} from "./utils";
import type {
  WrappedCashifyFunction,
  WrappedCashifyPageableQuery,
  GenericResponse,
  Sortable,
} from "./utils";
import type { SupportedLocale } from "components/supported-language";
import type { StandardObject } from "utils";

export interface MessagingHistoryService {
  listMessagingHistory: ReturnType<typeof listMessagingHistory>;
  getMessagingDetail: ReturnType<typeof getMessagingDetail>;
}

export type DeliveryStatus = "SUCCESSFUL" | "PENDING" | "FAILED";

export type MessageType = "SMS" | "PNS" | "EMAIL" | "UNKNOWN";

// Messaging History
export interface MessagingHistorySearchCriteria extends Sortable {
  id?: number;
  userId?: number;
  requestedBy?: string;
  deliveryStatus: DeliveryStatus[];
  messageType: MessageType[];
}

export interface MessagingHistoryDTO {
  id: number;
  tenantId: number;
  batchId?: string;
  deliveryStatus: DeliveryStatus;
  messageType: MessageType;
  userId?: number;
  recipient: string;
  templateName?: string;
  templateLocale?: SupportedLocale;
  deliveryDateTime?: string;
  requestedBy?: string;
}

export interface MessagingHistoryDetail extends MessagingHistoryDTO {
  otherRecipients?: StandardObject<string>;
  title?: string;
  content?: string;
  contentLength?: number;
  errorCode?: string;
  errorMessage?: string;
}

export const listMessagingHistory: WrappedCashifyPageableQuery<
  MessagingHistorySearchCriteria,
  MessagingHistoryDTO
> = ({ urlPrefix, options }) => {
  return async (queryParams) => {
    let url = getURLWithQueryParams(
      `${urlPrefix}/api/v1/messaging/delivery-history`,
      queryParams
    );
    let opts = extendFetchOptions(
      {
        method: "GET",
        headers: getDefaultHeaders(),
      },
      options
    );
    return fetch(url, opts).then((resp) => handleResp(resp));
  };
};

export const getMessagingDetail: WrappedCashifyFunction<
  { id: number },
  GenericResponse<MessagingHistoryDetail>
> = ({ urlPrefix, options }) => {
  return async ({ id }) => {
    let url = `${urlPrefix}/api/v1/messaging/delivery-history/${id}`;
    let opts = extendFetchOptions(
      {
        method: "GET",
        headers: getDefaultHeaders(),
      },
      options
    );
    return fetch(url, opts).then((resp) => handleResp(resp));
  };
};
